import ErrorMessage from './ErrorMessage';
import ClassNames from '../../constants/ClassNames';

export default class Error {
  class: string;
  message: ErrorMessage;

  /**
   * Initiate a new error class
   */
  constructor(message: string) {
    this.class = ClassNames.ERROR;
    this.message = new ErrorMessage(message);
  }

  /**
   * Show the error on the container
   */
  add(container: HTMLElement): void {
    container.classList.add(this.class);
    const errorMessageElement = container.querySelector('.error__message');
    if (!errorMessageElement) {
      container.appendChild(this.message.element);
    }
  }

  /**
   * Remove the error from the container
   */
  remove(container: HTMLElement): void {
    container.classList.remove(this.class);
    this.message.element.remove();
  }
}
